import { StreetAddress } from '../streetAddress/streetAddress';

export class PaymentMethod {
  id: string;
  tokenizedCardId: string;
  customerId: string;
  cardType: string;
  nickname: string | undefined = undefined;
  nameOnCard: string;
  cardExpMonth: string;
  cardExpYear: string;
  cardFirst6: string;
  cardLast4: string;
  billingAddress: StreetAddress | undefined;
  type: string | undefined = undefined;

  constructor(paymentMethod: Partial<PaymentMethod>) {
    /*
        Object.keys(this).forEach(key => {
            if (paymentMethod[key as keyof PaymentMethod] == null) {
                //throw Error(`${key} cannot be null`);
            }
        });
        Object.assign(this, paymentMethod);        
        */
    if (paymentMethod.id == undefined) {
      throw 'id required on payment method';
    } else if (paymentMethod.tokenizedCardId == undefined) {
      throw 'tokenizedCardId required on payment method';
    } else if (paymentMethod.customerId == undefined) {
      throw 'customer id required on payment method';
    } else if (paymentMethod.cardType == undefined) {
      throw 'card type required on payment method';
    } else if (paymentMethod.nameOnCard == undefined) {
      throw 'name on card required on payment method';
    } else if (
      paymentMethod.cardExpMonth == undefined ||
      paymentMethod.cardExpYear == undefined
    ) {
      throw 'card expiration required on payment method';
    } else if (
      paymentMethod.cardFirst6 == undefined ||
      paymentMethod.cardLast4 == undefined
    ) {
      throw 'card number required on payment method';
    }

    this.id = paymentMethod.id;
    this.tokenizedCardId = paymentMethod.tokenizedCardId;
    this.customerId = paymentMethod.customerId;
    this.cardType = paymentMethod.cardType;
    this.billingAddress = paymentMethod.billingAddress;
    this.cardExpMonth = paymentMethod.cardExpMonth;
    this.cardExpYear = paymentMethod.cardExpYear;
    this.cardFirst6 = paymentMethod.cardFirst6;
    this.cardLast4 = paymentMethod.cardLast4;
    this.nameOnCard = paymentMethod.nameOnCard;
    this.nickname = paymentMethod.nickname;
    this.type = paymentMethod.type;
    if (paymentMethod.nickname == null) {
      this.nickname = '****' + this.cardLast4;
    }
  }

  static createEmpty() {
    return new PaymentMethod({
      id: '',
      tokenizedCardId: '',
      customerId: '',
      cardType: '',
      nameOnCard: '',
      cardExpMonth: '',
      cardExpYear: '',
      cardFirst6: '',
      cardLast4: '',
      type: '',
    });
  }
}
